import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { AppBarTitlePortal } from '../../../../common/components/atoms/AppBarTitlePortal';
import LoadingSpinner from '../../../../common/components/molecules/LoadingSpinner';
import ModuleUpselling from '../../../../common/components/molecules/ModuleUpselling';
import { useAsqAccess } from '../../../../common/utils/accessHelper';
import { DepartureModule } from '../../asqModules';
import DeparturePage from '../pages/DeparturePage';

export default function DepartureContainer(): ReactElement {
  const { access, isLoading } = useAsqAccess();
  const { t } = useTranslation('Departure');

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (access?.hasDepartureGeneralAccess) {
    return <DeparturePage />;
  }

  return (
    <>
      <AppBarTitlePortal>
        <h4>{t('Title')}</h4>
      </AppBarTitlePortal>
      <ModuleUpselling module={DepartureModule} displayActions={false} />
    </>
  );
}
